module.exports = __webpack_public_path__ + "static/media/post Traumatic Stress DisorderActive.f04238ef.svg";